import type { LocalStorageFunctions } from './types';

const writeObject = (fn: Storage) => <T>(name: string, data: T) => {
  fn.setItem(name, JSON.stringify(data));
};

const readObject = (fn: Storage) => <T>(name: string): T | undefined => {
  const data = fn.getItem(name);
  if (data) return JSON.parse(data);
  return undefined;
};

const removeObject = (fn: Storage) => (name: string) => {
  fn.removeItem(name);
};

const localStorageFunctions = (fn: Storage): LocalStorageFunctions => ({
  writeObject: writeObject(fn),
  readObject: readObject(fn),
  removeObject: removeObject(fn)
});

export default localStorageFunctions;
